import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2198 6.2682C15.3683 5.88152 15.8022 5.68843 16.1889 5.83692L22.1289 8.11792C22.5155 8.26639 22.7086 8.70016 22.5602 9.08683L20.2802 15.0268C20.1318 15.4135 19.6979 15.6067 19.3112 15.4583C18.9245 15.3098 18.7314 14.876 18.8798 14.4893L20.511 10.2397L19.424 10.7237C17.0663 11.7689 15.1416 13.5956 13.9748 15.8954C13.8661 16.1097 13.6613 16.2589 13.424 16.2967C13.1867 16.3345 12.9456 16.2563 12.7757 16.0864L9 12.3107L2.78033 18.5304C2.48744 18.8233 2.01256 18.8233 1.71967 18.5304C1.42678 18.2375 1.42678 17.7626 1.71967 17.4697L8.46967 10.7197C8.76256 10.4268 9.23744 10.4268 9.53033 10.7197L13.1356 14.325C14.477 12.1369 16.455 10.3991 18.8158 9.35252C18.8159 9.35248 18.8158 9.35255 18.8158 9.35252L19.9012 8.86926L15.6511 7.23722C15.2645 7.08873 15.0714 6.65489 15.2198 6.2682Z"
        fill={colorValue}
      />
    </svg>
  );
};
